import PlaylistGames from '~/client/components/Game/GameView/GameViewDesktop/shared/PlaylistGames';
import GameDescription from '~/client/components/Game/GameView/shared/GameDescription';
import CasinoBoost from '~/client/features/CasinoBoost';
import InGameCurrency from '~/client/features/InGameCurrency';
import GameDetailsTable from '~/client/shared/game/GameDetailsTable';
import LazyLoad from '~/client/shared/LazyLoad';
import GameHeader from './GameHeader';
import MoreByProvider from './MoreByProvider';
import PlayButtons from './PlayButtons';
import ThemeBadges from './ThemeBadges';
import useGameContext from '../../context/Game/useGameContext';
import ClappsToggle from '../shared/ClappsToggle';

const GameViewMobile: FC = () => {
  const { game } = useGameContext();
  return (
    <div className="grid grid-cols-minmax gap-4">
      <GameHeader />
      <CasinoBoost module="game" />
      <InGameCurrency />
      <GameDetailsTable game={game} />
      <PlayButtons />
      <ThemeBadges />
      <ClappsToggle />
      <GameDescription />
      <LazyLoad>
        <MoreByProvider />
        <PlaylistGames />
      </LazyLoad>
    </div>
  );
};

export default GameViewMobile;
